
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vorur",
      function () {
        return require("private-next-pages/vorur/index.tsx");
      }
    ]);
  